import { render, staticRenderFns } from "./LoadingMainPanel.vue?vue&type=template&id=61e8163e"
import script from "./LoadingMainPanel.vue?vue&type=script&lang=js"
export * from "./LoadingMainPanel.vue?vue&type=script&lang=js"
import style0 from "./LoadingMainPanel.vue?vue&type=style&index=0&id=61e8163e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports